import { navDirections } from './navDirections'
import attendance from '../../Assets/attendance.svg'
import onlineClass from '../../Assets/onlineClass.svg'
import timetable from '../../Assets/timetable.svg'
import announcements from '../../Assets/announcements.svg'
import results from '../../Assets/results.svg'
import book from '../../Assets/book.svg'
import profile from '../../Assets/profile.svg'
import contact from '../../Assets/contact.svg'
import exams from '../../Assets/exams.svg'

export const panelNav = [
    {
        dest: navDirections.MY_PROFILE,
        text: 'My Profile',
        image: profile
    },
    {
        dest: navDirections.TIMETABLE,
        text: 'Timetable',
        image: timetable
    },
    {
        dest: navDirections.ONLINE_CLASS,
        text: 'Online Class',
        image: onlineClass
    },
    {
        dest: navDirections.EXAMS,
        text: 'Exams',
        image: exams
    },
    {
        dest: navDirections.ATTENDANCE,
        text: 'Attendance',
        image: attendance
    },
    {
        dest: navDirections.EXAM_RESULTS,
        text: 'Results',
        image: results
    },
    {
        dest: navDirections.HOME,
        text: 'Materials',
        image: book
    },
    {
        dest: navDirections.ANNOUNCEMENTS,
        text: 'Info',
        image: announcements
    },
    {
        dest: navDirections.CONTACT_US,
        text: 'Contact Us',
        image: contact
    }
]
